import * as actions from './actions'
import reducer from './reducer'
import * as selectors from './selectors'

export * from './models'

const profile = {
  actions,
  reducer,
  selectors,
}

export default profile
